<template>
  <MainMenuView :title="'Taxes'" @close="$emit('close')">
    <h3>Taxes</h3>
    <div class="d-flex justify-content-between">
      <label>Nexus States</label>
      <b-btn @click="addState" variant="primary">Add State</b-btn>
    </div>
    <i v-if="loading" class="far fa-spinner-third fa-spin"></i>
    <NexusStatesTable
      v-else
      ref="nexusStatesTable"
      :states="store.nexusStates"
      :availableStates="availableStates"
      :loading="loading"
      @remove="handleRemove"
      @submit="handleSubmit"
    />
  </MainMenuView>
</template>

<script>
import provinces from 'provinces';
import { updateStore } from '../../../../api/stores';

export default {
  name: 'Taxes',
  components: {
    MainMenuView: () => import('../MainMenuView'),
    NexusStatesTable: () => import('@/components/NexusStatesTable.vue')
  },
  props: {
    store: Object
  },
  data() {
    return {
      loading: false,
      usStates: []
    };
  },
  computed: {
    availableStates() {
      const countryCode = this.store.distributorId.country?.code || 'US';
      const states = provinces.filter(p => p.country === countryCode);
      return states.map(s => ({ ...s, abbreviation: s.short }));
    },
  },
  methods: {
    addState() {
      this.$refs.nexusStatesTable.addNewState();
    },
    handleRemove(state) {
      this.store.nexusStates = this.store.nexusStates.filter((ns) => ns.abbreviation !== state.abbreviation);
      this.saveStore();
    },
    handleSubmit(state) {
      const existingStateIndex = this.store.nexusStates.findIndex((ns) => ns.abbreviation === state.abbreviation);
      if (existingStateIndex > -1) {
        this.$set(this.store.nexusStates, existingStateIndex, state);
      } else {
        this.store.nexusStates.push(state);
      }
      this.saveStore();
    },
    async saveStore() {
      this.loading = true;
      try {
        await updateStore({
          _id: this.store._id,
          data: {
            nexusStates: this.store.nexusStates
          }
        });
        this.notifySuccess('Store updated successfully.');
      } catch (e) {
        this.notifyError('Failed to update store.');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
